import { render, staticRenderFns } from "./AffiliateActivityTable.vue?vue&type=template&id=6920d76c&scoped=true"
import script from "./AffiliateActivityTable.vue?vue&type=script&lang=js"
export * from "./AffiliateActivityTable.vue?vue&type=script&lang=js"
import style0 from "./AffiliateActivityTable.vue?vue&type=style&index=0&id=6920d76c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6920d76c",
  null
  
)

export default component.exports